import { AuthErrorCategory } from "../types";

type DerivableAuthError = {
  status: number;
  errors: unknown;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

/**
 * Auth flows other than login have no backend error kind, so failure reasons are
 * derived from the HTTP status and which field errors are present. Coarser than
 * login's `LoginErrorKind`; unmatched validation errors fall back to a generic bucket.
 */
export const deriveAuthErrorCategory = (error: DerivableAuthError): AuthErrorCategory => {
  const { status, errors } = error;
  if (status === 429) {
    return "rate_limited";
  }
  if (status >= 500) {
    return "server_error";
  }
  if (status === 400 || status === 422) {
    if (!isRecord(errors)) {
      return "validation_error";
    }
    if (errors.email) {
      return "invalid_email";
    }
    if (errors.number) {
      return "invalid_phone";
    }
    if (isRecord(errors.profile) && errors.profile.new_password) {
      return "invalid_password";
    }
    if (errors.username) {
      return "invalid_username";
    }
    return "validation_error";
  }
  return "unknown_error";
};
